import { OrganizationCountry } from "../enums/country";
export const countryHasPad = (country) => {
    return country === OrganizationCountry.Canada;
};
export const countryHasAch = (country) => {
    return country === OrganizationCountry.UnitedStates;
};
export const countryHasSepa = (country) => {
    return country === OrganizationCountry.Germany;
};
export const countryHasCashApp = (country) => {
    return country === OrganizationCountry.UnitedStates;
};
